import type { FaireProductEntity } from "../../entity_types/product";

export const p_pj3bcjdn95: FaireProductEntity = {
  token: "p_pj3bcjdn95",
  type: "product",
  name: "10\" Ring Light with Folding Stand",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/0e977964591e8e047007f80171a72b07f0c4159f5de5d428780e715deb32ca43.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff43aba79fc142ba7570491511d588fc9c561cc8056ea4244c8e9942e1786d64.jpeg",
    "https://cdn.faire.com/fastly/c3a70469190e30db037a120a073893439183a48fbbddd665f4d3d97e263f813e.jpeg",
    "https://cdn.faire.com/fastly/29e32c607a285ce719fea676148db13cadf71a3ee908f3e53f4a4718d3195620.jpeg",
    "https://cdn.faire.com/fastly/3361a89d465b305f5c8b52b29e4af44522947b8c53b0b021f594589324c6dd64.jpeg",
    "https://cdn.faire.com/fastly/0835192d86ec179531741795c11947aef7b25a7b6e66f4d504b64ef3d682e063.jpeg",
    "https://cdn.faire.com/fastly/e13a3857edb2b803f4641c334d4455b8f2bc06317beb6c852c64a1001773b943.jpeg"
  ],
  priceDollars: 30,
  description: "A portable 10\" ring light with a folding stand for product photos, videos and social content. The circular light gives bright, balanced illumination that helps minimize harsh shadows.\n\n- 10\" diameter ring light\n- Folding stand for quick setup, compact storage and travel\n\nUse it in the store, office, studio or on the go for online listings, social media and promotional images.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:04.926Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
